import type { CourseEmployeeFiltersFormT } from 'types';
import { z } from 'zod';

export const CourseEmployeeFiltersFormSchema = z.object({
  fullName: z
    .string()
    .optional()
    .describe('Nombre completo del empleado')
    .transform(value => value?.toLowerCase() || undefined),
  terminalId: z.string().uuid().optional().describe('ID de la terminal'),
  departmentId: z.string().uuid().optional().describe('ID del departamento'),
  jobTitleId: z.string().uuid().optional().describe('ID del cargo'),
  jobTitleTypeId: z.string().uuid().optional().describe('ID del tipo de cargo'),
});

export const defaultCourseEmployeeFiltersFormValues: CourseEmployeeFiltersFormT = {
  fullName: undefined,
  terminalId: undefined,
  departmentId: undefined,
  jobTitleId: undefined,
  jobTitleTypeId: undefined,
};
